module.exports = __webpack_public_path__ + "img/sld_down_arrow.00c10e14.svg";